


















import { useDebitCardManagementStore } from "@/shared/store/debitCardManagement";
import {
    Vue,
    Component
} from "@/shared/vuepack";
import ManageCardForm from "@/employee/components/settings/card-management/modal-content/ManageCardForm.vue";
import UpdatePinForm from "@/employee/components/settings/card-management/modal-content/UpdatePinForm.vue";
import PinsNotMatchingForm from "@/employee/components/settings/card-management/modal-content/PinsNotMatchingForm.vue";
import PinsMatchingPreviousForm from "@/employee/components/settings/card-management/modal-content/PinsMatchingPreviousForm.vue";
import PinSetCompleteForm from "@/employee/components/settings/card-management/modal-content/PinSetCompleteForm.vue";
import DeactivateCardForm from "@/employee/components/settings/card-management/modal-content/DeactivateCardForm.vue";
import ConfirmAddressForm from "@/employee/components/settings/card-management/modal-content/DeactivateCardAddressConfirmForm.vue";
import DeactivateCardCompleteForm from "@/employee/components/settings/card-management/modal-content/DeactivateCardCompleteForm.vue";
import RequestNewCardForm from "@/employee/components/settings/card-management/modal-content/RequestNewCardForm.vue";
import RequestNewCardConfirmForm from "@/employee/components/settings/card-management/modal-content/RequestNewCardConfirmForm.vue";
import RequestNewCardCompleteForm from "@/employee/components/settings/card-management/modal-content/RequestNewCardCompleteForm.vue";
import { DebitCardManagerModalViewState } from "@/shared/types";

@Component({
    components: {
        ManageCardForm,
        UpdatePinForm,
        PinsNotMatchingForm,
        DeactivateCardForm,
        PinSetCompleteForm,
        ConfirmAddressForm,
        DeactivateCardCompleteForm,
        RequestNewCardForm,
        RequestNewCardConfirmForm,
        RequestNewCardCompleteForm,
        PinsMatchingPreviousForm
    }
})
export default class DebitCardManagerModal extends Vue {
    debitCardManagementStore = useDebitCardManagementStore();
    DebitCardManagerModalViewState = DebitCardManagerModalViewState;

    get modalOpen () {
        return this.debitCardManagementStore.isModalOpen;
    }

    set modalOpen (value: boolean) {
        if (! value) { this.debitCardManagementStore.closeModal(); }
    }

    get viewState (): DebitCardManagerModalViewState {
        return this.debitCardManagementStore.modalViewState;
    }

    get titleText (): string {
        if (this.viewState === DebitCardManagerModalViewState.ManageCardForm) {
            return `Manage debit card ending in ${ this.debitCardManagementStore.focusedDebitCard.cardNumberLast4 }`;
        } else if (
            this.viewState === DebitCardManagerModalViewState.UpdatePinForm ||
            this.viewState === DebitCardManagerModalViewState.PinSetCompleteForm
        ) {
            return `Create/Update PIN`;
        } else if (this.viewState === DebitCardManagerModalViewState.PinsNotMatchingForm) {
            return `Warning`;
        } else if (this.viewState === DebitCardManagerModalViewState.PinsMatchingPreviousForm) {
            return `Warning`;
        } else if (this.viewState === DebitCardManagerModalViewState.RequestNewCardForm ||
            this.viewState === DebitCardManagerModalViewState.RequestNewCardConfirmForm ||
            this.viewState === DebitCardManagerModalViewState.RequestNewCardCompleteForm
        ) {
            return `Request a new card`;
        } else {
            return `Deactivate card & order a new one`;
        }
    }
}
